<div *ngIf="thenBlock; then thenBlock"></div>

<ng-template #step>
  <fl-step-app [form]="form"></fl-step-app>
</ng-template>

